module.exports = __webpack_public_path__ + "static/media/1POLICY16.0ef83f4c.jpg";